import { render, staticRenderFns } from "./ProductSingleRelated.vue?vue&type=template&id=b8d101ce&"
import script from "./ProductSingleRelated.vue?vue&type=script&lang=js&"
export * from "./ProductSingleRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports